import { mainRoutesURLs } from "./routes";

const adminPath = "/admin";
const mainPath = `/main/${mainRoutesURLs.agent1PagePath}`;

export type RoleRouteRule = {
  role: string;
  path: string;
  match?: (role: string) => boolean;
};

export const rolesURLs: RoleRouteRule[] = [
  { role: "Оператор", path: mainPath, match: (r) => r.trim() === "Оператор" },
  {
    role: "Суперадминистратор Tehnosky",
    path: adminPath,
    match: (r) => r.trim() === "Суперадминистратор Tehnosky",
  },
  // В бэке роль админа часто содержит уточнение (например, филиал),
  // поэтому матчим по префиксу.
  {
    role: "Администратор",
    path: adminPath,
    match: (r) => r.trim().startsWith("Администратор"),
  },
];
